import React, { ReactNode } from 'react';
import classNames from 'classnames';

import { Tooltip, TTypographyProps, Typography } from '../../components';

import styles from './FormLabel.module.scss';

export interface IFormLabelProps extends TTypographyProps<'label'> {
    tooltip?: ReactNode;
}

export const FormLabel: React.FC<IFormLabelProps> = ({ children, tooltip, className, ...props }) => {
    return (
        <Tooltip content={tooltip || children} contentProps={{ align: 'center' }}>
            <Typography
                component="label"
                fontWeight="medium"
                className={classNames(styles.label, className)}
                {...props}
            >
                {children}
            </Typography>
        </Tooltip>
    );
};
